import type { RouteConfigsTable } from "/#/index";
const Layout = () => import("@/layout/index.vue");

const remainingRouter: Array<RouteConfigsTable> = [
  // {
  //   path: "/login",
  //   name: "Login",
  //   component: () => import("@/views/login/index.vue"),
  //   meta: {
  //     title: "登录",
  //     showLink: false,
  //     visible: "1",
  //     rank: 101
  //   }
  // },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/main/main.vue"),
    meta: {
      title: "SHENGPAYET",
      showLink: false,
      visible: "1",
      rank: 101
    }
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/login/register.vue"),
    meta: {
      title: "注册",
      showLink: false,
      visible: "1"
    }
  },
  {
    path: "/setPassword",
    name: "SetPassword",
    component: () => import("@/views/login/set_password.vue"),
    meta: {
      title: "设置密码",
      showLink: false,
      visible: "1"
    }
  },
  {
    path: "/fgStep1",
    name: "FgStep1",
    component: () => import("@/views/login/fg_step1.vue"),
    meta: {
      title: "忘记密码",
      showLink: false,
      visible: "1"
    }
  },
  {
    path: "/fgStep2",
    name: "FgStep2",
    component: () => import("@/views/login/fg_step2.vue"),
    meta: {
      title: "找回密码实名认证",
      showLink: false,
      visible: "1"
    }
  },
  {
    path: "/fgStep3",
    name: "FgStep3",
    component: () => import("@/views/login/fg_step3.vue"),
    meta: {
      title: "重新设置密码",
      showLink: false,
      visible: "1"
    }
  },
  {
    path: "/outResult",
    name: "OutResult",
    component: () => import("@/views/login/result.vue"),
    meta: {
      title: "成功",
      showLink: false,
      visible: "1"
    }
  },
  {
    path: "/certif",
    name: "Certif",
    component: () => import("@/views/certif/certif.vue"),
    meta: {
      title: "实名认证",
      showLink: false,
      visible: "1"
    }
  },
  {
    path: "/certifV2",
    name: "CertifV2",
    component: () => import("@/views/certif/certif_V2.vue"),
    meta: {
      title: "实名认证",
      showLink: false,
      visible: "1"
    }
  },
  {
    path: "/certifRe",
    name: "CertifRe",
    component: () => import("@/views/certif/certif_replenish.vue"),
    meta: {
      title: "实名认证补充材料",
      showLink: false,
      visible: "1"
    }
  },
  {
    path: "/risk-country",
    name: "riskCountry",
    component: () => import("@/views/certif/risk_country.vue"),
    meta: {
      title: "禁入国家/地区",
      showLink: false,
      visible: "1"
    }
  },
  {
    path: "/risk-goodsList",
    name: "riskGoodsList",
    component: () => import("@/views/certif/risk_goodsList.vue"),
    meta: {
      title: "禁入商品列表",
      showLink: false,
      visible: "1"
    }
  },
  {
    path: "/redirect",
    component: Layout,
    meta: {
      icon: "home-filled",
      title: "首页",
      showLink: false,
      visible: "1",
      rank: 104
    },
    children: [
      {
        path: "/redirect/:path(.*)",
        name: "Redirect",
        component: () => import("@/layout/redirect.vue")
      }
    ]
  }
];

export default remainingRouter;
